"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.posRecordGenerator = posRecordGenerator;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const turf_1 = require("@turf/turf");
const TurfUtils_1 = require("../TurfUtils");
/** generates a series of location and timestamps emulating an object moving along the input path at the input speed.
 * If reversePathAtDestination is true, the object will return back down the path when it reaches its last defined point
 */
function* posRecordGenerator({ path, speedKmh, reversePathAtDestination }) {
    if (path.length < 2)
        throw new Error('zero or one length path');
    let t0 = Date.now();
    let lastTimestamp = t0;
    let consumablePath = [...path];
    let location = consumablePath.at(0);
    const totalRoughDistanceKm = (0, turf_1.distance)((0, TurfUtils_1.gPointToTPosition)(consumablePath.at(0)), (0, TurfUtils_1.gPointToTPosition)(consumablePath.at(consumablePath.length - 1)), { units: 'kilometers' });
    const isLastPosition = (location, path) => (0, iotv_v3_types_1.objectsMatch)(location ?? { never: true }, path.at(path.length - 1));
    while (!isLastPosition(location, consumablePath)) {
        const thisTimestamp = Date.now();
        const distanceTravelledMtrs = ((thisTimestamp - lastTimestamp) / iotv_v3_types_1.Milliseconds.HOUR) * speedKmh * 1000;
        const { reducedPath } = reducePathByDistance({ path: consumablePath, reduceBy: distanceTravelledMtrs, units: 'meters' });
        consumablePath = reducedPath;
        const nextLocation = consumablePath.at(0);
        if ((0, iotv_v3_types_1.isPosition)(nextLocation)) {
            location = nextLocation;
            if (reversePathAtDestination && isLastPosition(location, consumablePath)) {
                consumablePath = path.reverse();
            }
        }
        lastTimestamp = thisTimestamp;
        yield { location, timestamp: lastTimestamp };
    }
    const durationHr = (Date.now() - t0) / iotv_v3_types_1.Milliseconds.HOUR;
    const roughSpeed = totalRoughDistanceKm / durationHr;
    console.log('Rough distance km', totalRoughDistanceKm);
    console.log('Rough speed kmh', roughSpeed);
}
const reducePathByDistance = ({ path, reduceBy, units }) => {
    if (path.length < 2) {
        throw new Error(`Path is zero or one length`);
    }
    const reducedPath = [...path];
    const consumedPath = []; // reminder for if this is needed to reverse at end in future
    let consumedDistance = 0;
    do {
        const distanceToConsume = reduceBy - consumedDistance;
        const [start, end] = reducedPath;
        if (start && end) {
            const distanceBetweenPoints = (0, TurfUtils_1.getGLineDistance)(start, end, units);
            if (distanceBetweenPoints < distanceToConsume) {
                consumedPath.push(...reducedPath.splice(0, 1));
                consumedDistance += distanceBetweenPoints;
            }
            else {
                /* new point will fall between start and end */
                const tStart = (0, TurfUtils_1.gPointToTPosition)(start);
                const tEnd = (0, TurfUtils_1.gPointToTPosition)(end);
                const currentTPosition = (0, turf_1.along)((0, turf_1.lineString)([tStart, tEnd]), distanceToConsume, { units });
                const newPoint = (0, TurfUtils_1.tPositionToGPoint)(currentTPosition.geometry.coordinates);
                consumedDistance += distanceToConsume;
                const replacedFirstPoint = reducedPath.splice(0, 1, newPoint);
                break;
            }
        }
        else {
            break;
        }
    } while (consumedDistance < reduceBy);
    return { reducedPath };
};
